import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductManagementService } from 'src/service/product-management.service';
import { ConfigurationManagementService } from '../../service/configuration-management.service';
import { CountryManagementService } from '../../service/country-management.service';
import { LanguageManagementService } from '../../service/language-management.service';
import { InteractionType, KeyValues5, KeyValues10, LastUsedSettingsType, LocalService, Menus, PageKey, Status, TriggeredEvent, SummaryType, GeneralConfigType, AllowedPageAction, FocusInputType, LastUsedKey, BillingStatus, LoginAsParam } from '../../service/local.service';
import { MenuManagementService } from '../../service/menu-management.service';
import { ProfileManagementService } from '../../service/profile-management.service';
import { DelivererConfigComponent } from '../popups/deliverer-config/deliverer-config.component';
import { EditAdditionalDetailsComponent } from '../popups/edit-additional-details/edit-additional-details.component';
import { LessCreditsComponent } from '../popups/less-credits/less-credits.component';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PrinterService } from 'src/service/printer.service';
import { DevicePrinterSetup } from '../entities/request';
import { SellerManagementService } from 'src/service/seller-management.service';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { WsOfflineService } from 'src/service/ws/ws-offline.service';
import { EmitResponse, EmitResponseWithSource } from 'src/service/ws/wsSupporting/wsEntities';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';
import { Constant } from '../supporting/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: { '(document:click)': 'onFocusOut($event)' }
})
export class HeaderComponent implements OnInit {
  InteractionType = InteractionType;
  isShowMenuList: boolean = false; isInitialNotification = true; isShowNotificationBar = false; notificationHeight = 0;
  notifications: KeyValues5[] = []; loadedNotifications: string[] = []; environmentName = environment.current_environment_name; menusToDisplay: Menus[] = []; searchBoxWidth = 100;
  lastScroll = 0; isPopupOpened = false; version = '-'; searchKey = ''; server = environment.server;
  isRequeCheckInitiated = false;

  isOpenLanguageSelection = false; isShowAllLanguageSelection = false;
  isOpenLogin = false; isOpenUserAuthentication = false;
  isPrimiaryServiceVerified = false;

  private audio = new Audio(); isShowNewBillAlert = false;
  elementIds: any = {
    btn_login_logout: 'btn_login_logout',
    btn_change_language: 'btn_change_language',
    txt_search_key: 'txt_search_key'
  };

  constructor(public localService: LocalService, private httpCall: HttpClient, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private router: Router, private _eref: ElementRef, private menuManagementService: MenuManagementService, public profileManagementService: ProfileManagementService, private countryManagementService: CountryManagementService, private configurationManagementService: ConfigurationManagementService, private productManagementService: ProductManagementService, private printerService: PrinterService, private sellerManagementService: SellerManagementService, private wsUserService: WsUserService, private wsOfflineService: WsOfflineService) {
    this.audio.src = 'assets/sounds/dragon-studio-alert-444816.mp3';
    this.audio.load();
  }

  ngOnInit(): void {
    this.localService.basicParams = undefined;
    this.version = Constant.Version;
    if (!this.isPrimiaryServiceVerified) {
      (async () => {
        await this.onCheckPrimaryService();
      })();
    }
  }

  playAlert() {
    this.audio.play().catch(error => {
      console.log('Playback failed:', error);
    });
  }

  onCheckPrimaryService() {
    const isPrimaryServiceDownBefore = this.localService.isPrimaryServiceDown;
    this.httpCall.get(environment.url.service + 'version').toPromise()
      .then(response => {
        const result = response as any;
        this.localService.isPrimaryServiceDown = !(result && result.version && result.version.length > 5);
        this.isPrimiaryServiceVerified = true;
        if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
          this.configurationManagementService.onEnsureServiceDown();
        }
        this.onInitiate();
      }).catch(error => {
        this.localService.isPrimaryServiceDown = true;
        this.isPrimiaryServiceVerified = true;
        if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
          this.configurationManagementService.onEnsureServiceDown();
        }
        this.onInitiate();
      });
  }

  onInitiate() {
    if (this.isPrimiaryServiceVerified) {
      this.onCheckReques();
    } else {
      setTimeout(() => { this.onInitiate() }, 1000);
    }
  }

  onLoadRedirect() {
    const url = window.location.href;
    setTimeout(() => {
      const redirect = '?redirect=';
      if (url.indexOf(redirect) > -1) {
        const urls = url.split(redirect);
        if (urls.length > 1) {
          const routeUrl = urls[1].replace(/%2F/g, '/');
          this.localService.redirectUrlAfterLogin = routeUrl;
          this.router.navigate(['/' + routeUrl]);
        }
      }
    }, 1000);
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.onInitiateAfterVerified();
          }
        });
      } else {
        this.onInitiateAfterVerified();
      }
    } else {
      this.onInitiateAfterVerified();
    }
  }

  onInitiateAfterVerified() {
    this.ensureOfflineDataBeforeLogin();
    this.onLoadRedirect();
    this.localService.windowWidth = window.innerWidth;
    if (!this.localService.isDirectUrl()) {
      this.localService.getMenuCollapsed();
      this.localService.getMenuHidden();
      this.onLoad();
    } else if (!this.localService.isPlainDirectUrl()) {
      this.languageManagementService.onLoad();
    }
  }

  onLoad() {
    this.profileManagementService.getLastUsedSettings().subscribe(result => {
      this.localService.lastUsedSettings = result;
      this.localService.selected.applicationLanguage = this.localService.getLastUsedSetting(LastUsedSettingsType.ApplicationLanguage);
      //this.localService.selected.localLanguage = this.localService.getLastUsedSetting(LastUsedSettingsType.LocalLanguage);
      this.countryManagementService.ensureCountryCodes();
      this.languageManagementService.onLoad();
    });
  }

  onResize(e) {
    this.localService.windowWidth = window.innerWidth;
    this.localService.windowHeight = window.innerHeight;
    this.localService.sideBarBodyHeight = window.innerHeight - 120;
  }

  onGetBusiness() {
    if (this.localService.selected && !this.localService.viewAsReturnCountryCodeUserId) {
      if (this.notifications.length == 0)
        this.isShowNotificationBar = false;
      if (this.localService.selected.user != '') {
        this.menuManagementService.getNotifications(this.localService.selected.user, this.isInitialNotification, false, null, null).subscribe(result => {
          if (result.status == Status.Blocked || result.status == Status.UnAvailable) {
            this.onLoginLogout();
          } else {
            if (this.localService.loggedMember) {
              this.localService.loggedMember.businesses = result.businesses;
              this.localService.loggedMember.allowedMenus = result.allowedMenus;
              this.localService.loggedMember.deviceSettings = result.deviceSettings;
              this.localService.loggedMember.printerNamesWithReceiptTemplates = result.printerNamesWithReceiptTemplates;
              this.localService.loggedMember.weightMachines = result.weightMachines;
              this.localService.loggedMember.receiptTemplates = result.receiptTemplates;
              this.onFilterMenu();
            }
            this.onCheckWsUserEmitDetection();
            this.onCheckWsBusinesEmitDetection();
            //if (this.isInitialNotification == false) {
            //  let ids = this.notifications.map(item => item.key);
            //  Array.prototype.push.apply(this.loadedNotifications, ids);
            //}
            if (this.isInitialNotification) {
              this.notifications = [];
              this.isInitialNotification = false;
            }
            if (result != null && result.status == Status.Success && result.wrapper.items.length > 0)
              this.notifications.unshift(...result.wrapper.items);
          }
        });
      }
    }
  }

  onAsCountryChange() {
    this.localService.onTriggerClass('on_as_country_changed', 100);
  }

  onCheckWsUserEmitDetection() {
    if (this.localService.selected && this.localService.selected.user) {
      let businessIds: string[] = this.localService.loggedMember.businesses.filter(x => x.v5 == 'BU').map(x => x.key);

      if (this.localService.loggedMember.brnIds && this.localService.loggedMember.brnIds.length > 0) {
        businessIds = businessIds.concat(this.localService.loggedMember.brnIds);
      }

      this.wsUserService.registerUser(this.localService.selected.user, businessIds, this.localService.selected.countryCode);

      this.wsUserService.onEmitDetected(RegisterName.UserEmitDetected).subscribe((res: EmitResponseWithSource) => {
        switch (res.emitType) {
          case EmitType.UserLogged:
          case EmitType.ResetToken: {
            if (this.localService.loggedMember
              && this.localService.loggedMember.loggedMember.content.key == res.result.userId
              && this.localService.loggedMember.loggedMember.content.v10 != res.result.currrentToken) {
              this.onLoginLogout();
            }
          } break;
          case EmitType.ForceLogout:
          case EmitType.UserSystemDataChanged:
          case EmitType.BusinessSystemDataChanged: {
            if (this.localService.loggedMember.loggedMember.content.key == res.result.userId) {
              this.onLoginLogout();
            }
          } break;
          case EmitType.BusinessUpdated:
          case EmitType.BusinessAssignedOrRemoved:
          case EmitType.DeviceSettingsChanged: {
            if (this.localService.loggedMember.loggedMember.content.key == res.result.userId) {
              this.onGetBusiness();
            }
          } break;
        }
      });
    }
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      switch (res.emitType) {
        case EmitType.RefreshBusiness: {
          this.sellerManagementService.getBusinesses(false, false).subscribe(result => {
            this.localService.loggedMember.businesses = result;
          });
        } break;
        case EmitType.BillingStatusUpdated: {
          if (res.result.status == BillingStatus.Submitted) {
            this.isShowNewBillAlert = true;
            this.playAlert();
          }
        } break;
      }
    });
  }

  onCloseAlert() {
    this.isShowNewBillAlert = false;
  }

  onShowHideNotification() {
    this.notificationHeight = window.innerHeight - 60;
    this.isShowNotificationBar = !this.isShowNotificationBar;
  }

  onCollapseMenu(id) {
    if (this.localService.collapsedMenu.indexOf(id) > -1)
      this.localService.collapsedMenu = this.localService.collapsedMenu.filter(x => x != id);
    else
      this.localService.collapsedMenu.push(id);
    this.localService.setMenuCollapsed();
  }

  openLanguagSelection() {
    this.isOpenLanguageSelection = true;
  }

  onCopyUrl() {
    const url = window.location.href;
    let domain = environment.url.app;
    if (domain.endsWith('/')) {
      domain = domain.substring(0, domain.length - 1);
    }
    const routeUrl = url.replace(domain, '');
    const dpath = domain + (routeUrl && routeUrl.length > 0 ? '/?redirect=' + routeUrl : '');
    this.localService.copyContent(dpath);
  }

  onLoginLogout(isDirectClick = false) {
    if (this.localService.selected.user) {
      this.onSetHiddenMenus();
      this.localService.isEnableAutoLoginNextTime = false;
      this.localService.setLastUser();
      this.localService.onLogout();

      if (this.localService.viewAsCountryCodeUserId || this.localService.viewAsReturnCountryCodeUserId) {
        this.onLoad();
        setTimeout(() => {
          //this.localService.onAutoLogin();

          if (isDirectClick)
            this.localService.viewAsCountryCodeUserId = null;
        }, 500);
      }
      this.onFilterMenu();
    }
    else {
      this.localService.allowedPageActions = [] as AllowedPageAction[];
      this.isOpenLogin = true;
    }
  }

  onCloseLogin(result) {
    if (result) {
      if (result.event == TriggeredEvent.Ok) {
        this.ensureOfflineData();
        this.onCheckLessAlerts();
        this.onFilterMenu();

        let elementToClick = document.getElementsByClassName('on_login_success');
        if (elementToClick && elementToClick.length > 0) {
          for (let i = 0; i < elementToClick.length; i++) {
            let toClick: HTMLDivElement = elementToClick[i] as HTMLDivElement;
            toClick.click();
          }
        }
      }
    }
  }

  onCloseLanguageSelection(result) {
    this.searchKey = '';
    if (this.localService.redirectUrl && this.localService.redirectUrl.startsWith(this.localService.barCodePrefix)) {
      this.localService.onFocusNextInput('btn_login_logout', FocusInputType.Button, true);
    }
  }

  onCheckLessAlerts() {
    this.profileManagementService.getLessAlert().subscribe(result => {
      if (result && (result.lessStockBusiness.length > 0 || result.messageCredits.length > 0)) {
        const modalRef = this.modalService.open(LessCreditsComponent);
        modalRef.componentInstance.lessAlert = result;
      }
    });
  }

  ensureOfflineData() {
    if (this.localService.selected.user) {
      this.productManagementService.ensureUsageLimits();
      this.localService.billingStatus = null;
      let iConfigTypes = [GeneralConfigType.BillingStatus, GeneralConfigType.DeliveryType, GeneralConfigType.PaymentType, GeneralConfigType.BusinessType, GeneralConfigType.QrPaymentStatus, GeneralConfigType.DeductionMethod, GeneralConfigType.PlanPurchaseInvoiceStatus];

      if (this.localService.galleryTypes) {
        iConfigTypes.push(GeneralConfigType.GalleryType);
      }

      if (this.localService.receiptOptions) {
        iConfigTypes.push(GeneralConfigType.ReceiptOption);
      }

      this.configurationManagementService.getConfigurationsToDisplayMulti(iConfigTypes, true, false).subscribe(result => {
        result.forEach(item => {
          switch (parseInt(item.key)) {
            case GeneralConfigType.BillingStatus: {
              this.localService.billingStatus = item.value;
            } break;
            case GeneralConfigType.DeliveryType: {
              this.localService.deliveryTypes = item.value;
            } break;
            case GeneralConfigType.PaymentType: {
              this.localService.paymentTypes = item.value;
            } break;
            case GeneralConfigType.BusinessType: {
              this.localService.businessTypes = item.value;
            } break;
            case GeneralConfigType.GalleryType: {
              this.localService.galleryTypes = item.value;
            } break;
            case GeneralConfigType.ReceiptOption: {
              this.localService.receiptOptions = item.value;
            } break;
            case GeneralConfigType.QrPaymentStatus: {
              this.localService.qrPaymentStatus = item.value;
            } break;
            case GeneralConfigType.DeductionMethod: {
              this.localService.deductionMethods = item.value;
            } break;
            case GeneralConfigType.PlanPurchaseInvoiceStatus: {
              this.localService.planPurchaseInvoiceStatuses = item.value;
            } break;
          }
        });
      });
    }
  }

  onSetBusinessPriterSetup(businessIds: string[]) {
    this.localService.businesesPrinterSetup = [];
    if (businessIds.length > 0) {
      this.printerService.getPrinterSetupByBusinessIds(this.localService.selected.countryCode, businessIds).subscribe(result => {
        if (result) {
          this.localService.businesesPrinterSetup = result;
        }
      });
    }
  }

  ensureOfflineDataBeforeLogin() {
    const configs = [GeneralConfigType.CountryLocationLevel, GeneralConfigType.MeasurementType, GeneralConfigType.LookupType];
    this.configurationManagementService.getConfigurationsToDisplayMulti(configs, true, false).subscribe(result => {
      result.forEach(item => {
        switch (parseInt(item.key)) {
          case GeneralConfigType.CountryLocationLevel: {
            this.localService.countryLocationLevels = item.value;
          } break;
          case GeneralConfigType.MeasurementType: {
            this.localService.measurementTypes = item.value;
          } break;
          case GeneralConfigType.LookupType: {
            this.localService.lookupTypes = item.value;
          } break;
        }
      });
    });
  }

  onMenuClicked(item: KeyValues10 = null) {
    let id = item ? item.key : '';
    let url = item ? item.v4 : '';
    if (this.localService.selected && this.localService.selected.user) {
      switch (url) {
        case '#AdditionalDetails#': {
          this.onOpenAdditionalDetails();
          this.isShowMenuList = false;
        } break;
        case '#LanguageSelection#': {
          this.openLanguagSelection();
          this.isShowMenuList = false;
        } break;
        case '#ManageService#': {
          this.onOpenServiceProvider();
          this.isShowMenuList = false;
        } break;
        case '#Login#':
        case '#Logout#': {
          this.onLoginLogout();
        } break;
        case '#AddEmployee#': {
          this.onUserAuthentication();
          this.isShowMenuList = false;
        } break;
        default: {
          if (url && url != '')
            this.localService.selectedMenu = item;
          url = url.replace('#userId#', this.localService.selected.user);
          url = url.replace('#ctryCode#', this.localService.selected.countryCode);
          if (url.indexOf('#serviceId#') > -1) {
            let serviceId = this.localService.getId('', InteractionType.ServiceProvider);
            url = url.replace('#serviceId#', serviceId == '' ? '0' : serviceId);
          }

          let businessId = '0';
          if (url.indexOf('#businessId#') > -1) {
            businessId = this.localService.getId(url, InteractionType.Business);
            if (businessId != '-1')
              url = url.replace('#businessId#', businessId);
          }

          businessId = '0';
          if (url.indexOf('#userOrbusinessId#') > -1) {
            businessId = this.localService.getId(url, InteractionType.User);
            if (businessId != '-1')
              url = url.replace('#userOrbusinessId#', businessId);
          }

          if (url != '' && url != '#' && url.indexOf('#businessId#') == -1 && url.indexOf('#userOrbusinessId#') == -1)
            this.router.navigate(['/' + url]);
          else if (url == '#') {
            this.showHideSubMenu(id);
          }

          this.isShowMenuList = !url || url == '' ? !this.isShowMenuList : false;
        }
      }
      this.onLastUrlSave();
    } else if (url != '') {
      this.localService.selectedMenu = item;
      this.isShowMenuList = false;
      if (this.localService.menusWithoutLogin.filter(x => url.indexOf(x) > -1).length > 0) {
        this.router.navigate(['/' + url]);
      } else {
        this.onLoginLogout();
      }
    } else {
      this.isShowMenuList = !this.isShowMenuList;
    }
    this.localService.setSelectedMenu();
    this.setScroll();
  }

  onPageKeyPressed() {
    let item = this.localService.getPageKeyMenu(this.localService.navigateToPage, this.localService.publicMenus);
    if (item) {
      this.onMenuClicked(item);
    }
  }

  onUserAuthentication() {
    if (!this.isPopupOpened) {
      this.isPopupOpened = true;
      this.isOpenUserAuthentication = true;
    }
  }

  onCloseUserAuthentication(isFromAnotherPopup: boolean, result?: any) {
    this.isPopupOpened = false;
    if (isFromAnotherPopup) {
      result = this.localService.dataWhileClosingPopupAndTriggerButton;
    }
    if (result) {

    }
    if (isFromAnotherPopup) {
      this.localService.dataWhileClosingPopupAndTriggerButton = undefined;
    }
  }

  onOpenServiceProvider() {
    if (!this.isPopupOpened) {
      this.isPopupOpened = true;
      const modalRef = this.modalService.open(DelivererConfigComponent);
      modalRef.componentInstance.id = this.localService.getId('', InteractionType.ServiceProvider);
      modalRef.result.then((result) => {
        this.isPopupOpened = false;
        if (result.event == TriggeredEvent.Ok) {

        }
      }, (error) => {
        this.isPopupOpened = false;
      });
    }
  }

  onOpenAdditionalDetails() {
    if (!this.isPopupOpened) {
      this.isPopupOpened = true;
      const modalRef = this.modalService.open(EditAdditionalDetailsComponent);
      modalRef.componentInstance.id = this.localService.selected.user;
      modalRef.componentInstance.ctryCode = this.localService.selected.countryCode;
      modalRef.result.then((result) => {
        this.isPopupOpened = false;
        if (result.event == TriggeredEvent.Ok) {
        }
      }, (error) => {
        this.isPopupOpened = false;
      });
    }
  }

  onRoute(index) {
    switch (index) {
      case 1: {
        this.localService.onNavigateToPage(PageKey.QrCode);
      } break;
      case 2: {
        this.localService.showSummary(this.localService.currentPageKey, SummaryType.Guide);
      } break;
    }
    this.onLastUrlSave();
  }

  showHideSubMenu(parentId: string) {
    const businessId = this.localService.basicParams?.businessId;
    if (businessId) {
      let item = this.localService.loggedMember.allowedMenus.find(x => x.businessId == businessId).menus.find(x => x.menu.key == parentId);
      let isShown = item.menu.isReadonly == undefined ? false : item.menu.isReadonly;
      let oldItem = this.localService.loggedMember.allowedMenus.find(x => x.businessId == businessId).menus.find(x => x.menu.isReadonly);
      if (oldItem != undefined)
        this.localService.loggedMember.allowedMenus.find(x => x.businessId == businessId).menus.find(x => x.menu.isReadonly).menu.isReadonly = false;
      this.localService.loggedMember.allowedMenus.find(x => x.businessId == businessId).menus.find(x => x.menu.key == parentId).menu.isReadonly = !isShown;
    }
  }

  public onLanguageChanged() {
    this.onLoadPublicMenu();
    this.countryManagementService.ensureCountryCodes(true);
    this.ensureOfflineData();
    this.ensureOfflineDataBeforeLogin();
    if (this.localService.loggedMember != undefined) {
      this.notifications = [];
      this.isInitialNotification = true;
      this.onLoadHeaders();
    }
  }

  onLoadHeaders() {
    this.menuManagementService.getHeader().subscribe(result => {
      this.localService.languagesEquivalent = result.equivalent;
      this.localService.selectedPageName = this.localService.getPageKeyName();
      this.onFilterMenu();
    });
  }

  onLoadPublicMenu() {
    this.menuManagementService.getPublicMenus('', false).subscribe(result => {
      this.localService.publicMenus = result.menus;
      this.onSetHiddenMenus();
      this.localService.languagesEquivalent = result.equivalent;
      this.onFilterMenu();
    });
  }

  onSetHiddenMenus() {
    if (this.localService.publicMenus) {
      this.localService.publicMenus.forEach(menu => {
        if (menu && menu.subMenus) {
          menu.subMenus.forEach(subMenu => {
            subMenu.menu.isSelected = !(this.localService.hiddenMenu.indexOf(subMenu.menu.key) > -1);
          });
        }
      });
    }
  }

  onFocusOut(event) {
    if (this.isShowMenuList || this.isShowNotificationBar) {
      var target = event.target as Element;
      if (!this._eref.nativeElement.contains(target) && target.className.indexOf('notification_cancel') == -1 && target.className.indexOf('scrollTopMenu') == -1) // or some similar check
      {
        this.isShowMenuList = false;
        this.isShowNotificationBar = false;
      }
    }
    this.localService.setSelectedMenu();
  }

  isMinumumOneMenuAvailable(parentMenuKey: string): boolean {
    if (this.localService.loggedMember) {
      let subMenus = this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus.find(x => x.menu.key == parentMenuKey);
      return subMenus && subMenus.subMenus ? subMenus.subMenus.filter(x => x.menu.isSelected).length > 0 : false;
    } else {
      let subMenus = this.localService.publicMenus.find(x => x.menu.key == parentMenuKey);
      return subMenus && subMenus.subMenus ? subMenus.subMenus.filter(x => x.menu.isSelected).length > 0 : false;
    }
  }

  onMarkAsRead(key: string, isNavigation = false) {
    if (isNavigation)
      this.isShowNotificationBar = false;
    if (key != 'A')
      this.notifications.find(x => x.key == key).isReadonly = true;
    this.menuManagementService.markAsRead(key).subscribe(result => {
      if (result.status == Status.Success) {
        if (key == 'A') {
          this.notifications = [];
        } else {
          this.notifications = this.notifications.filter(x => x.key != key);
        }
        if (this.notifications.length == 0)
          this.isShowNotificationBar = false;
      } else if (key != 'A') {
        this.notifications.find(x => x.key == key).isReadonly = false;
      }
    });
  }

  setScroll() {
    if (this.isShowMenuList) {
      this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
      setTimeout(() => {
        var menu_options = document.getElementById('menu_options') as HTMLDivElement;
        if (menu_options) {
          menu_options.scrollTop = this.lastScroll;
          this.searchBoxWidth = menu_options.clientWidth;
        }

        var menu_options_icon = document.getElementById('menu_options_icon') as HTMLDivElement;
        if (menu_options_icon)
          menu_options_icon.scrollTop = this.lastScroll;
      }, 5);
    }
  }

  scrollHandler(e) {
    this.lastScroll = e.target.scrollTop;
  }

  onSetToTop() {
    this.lastScroll = 0;
    this.setScroll();
  }

  onLastUrlSave() {
    setTimeout(() => {
      if (this.localService.selected.user) {
        if (this.router.url && this.router.url != '/' && this.router.url.indexOf('#') == -1 && this.router.url != this.localService.getLastUsedSetting(LastUsedSettingsType.VisitedURL)) {
          this.profileManagementService.saveLastUsedSetting({ keyType: LastUsedSettingsType.VisitedURL, value: this.router.url } as LastUsedKey).subscribe(result => {
          });
        }
      }
    }, 1000);
  }

  onGetLoggedMenu() {
    return this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus ?? [];
  }

  onFilterMenu() {
    const menusItems = JSON.parse(JSON.stringify(this.localService.selected.user != '' ? this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus : this.localService.publicMenus));
    if (this.searchKey && this.searchKey.trim()) {
      let rtn: Menus[] = [];
      const search = this.searchKey.trim().toLowerCase();
      menusItems.forEach(menuItem => {
        const items = menuItem.subMenus.filter(x => x.menu.v3 && !x.menu.v4.startsWith('#Log') && x.menu.v5.toLowerCase().indexOf(search) > -1);
        if (items.length > 0) {
          let menuToAdd = menuItem;
          menuToAdd.subMenus = items as Menus[];
          rtn.push(menuToAdd);
        }
      });
      this.menusToDisplay = rtn;
    } else {
      this.menusToDisplay = menusItems;
    }
  }
}
